<script>
  import '$styles'
  import { onMount } from 'svelte'
  import { inProduction, isApp } from '@st-graphics/graphics-kit/environment'
  import { isPremium, premiumClient, user } from '@st-graphics/graphics-kit/state'
  import { jsonBaseURI } from '@st-graphics/graphics-kit/urls'
  import { parseLongForm } from '@st-graphics/graphics-components/utils'

  import {
    Analytics,
    Favicons,
    Footer,
    Main,
    Meta,
    StructuredData,
    MySPH,
    ResourceHints,
    Skippy,
  } from '@st-graphics/graphics-components'
  import { Article } from '$components'

  let { data } = $props()

  let { copyId, header, theme, menu } = $derived(data)
  let copy = $state(parseLongForm(data))
  let head = $derived(header)

  onMount(async () => {
    //  // TODO: Need deeper investigation on how this affects premium stories.
    if (inProduction) {
      try {
        const url = `${jsonBaseURI}/${copyId}.json`
        const response = await fetch(url)

        if (!response.ok) {
          throw new Error(`Request failed: ${response.status} ${response.statusText}`)
        }

        const jsonLastModified = new Date(response.headers.get('Last-Modified'))
        const documentLastModified = new Date(document.lastModified)

        if (jsonLastModified > documentLastModified) {
          let json

          if (isPremium.current && premiumClient.current && user.isSubscriber) {
            json = await premiumClient.current.fetchContent(`${copyId}.json`)
          } else {
            json = await response.json()
          }

          copy = parseLongForm(json)
        }
      } catch (err) {
        console.error(err)
      }
    }

    // No need to update the theme after publishing.
    document.documentElement.dataset.theme = theme ?? 'light'
  })
</script>

{#if !copy.header.datetime}
  <div class="publish-error">Publish Date-Time is invalid!</div>
{/if}

<Meta title={copy.title} meta={copy.meta} header={copy.header} />

<StructuredData
  title={copy.title}
  pubdate={copy.pubDate}
  modifieddate={copy.modifiedDate}
  header={copy.header}
  credits={copy.credits}
  meta={copy.meta}
/>
<Favicons />
<ResourceHints />
<Analytics title={copy.title} pubdate={copy.pubDate} />
<MySPH />
<Skippy />

<!-- Ignore `APP_VERSION` is not defined warning. -->
<div class="st-page" data-copy-id={copyId} data-app-version={APP_VERSION}>
  <div class="st-content">
    <Main>
      <Article {copy} {menu} />
    </Main>
  </div>

  {#if !isApp}
    <Footer />
  {/if}
</div>

<style lang="scss">
  .st-page {
    display: grid;
    grid-template-rows: auto 1fr auto;
    grid-template-columns: 100%;
    min-height: 100vh;

    @supports (min-height: 100dvh) {
      min-height: 100dvh;
    }
  }

  :global(.is-app .st-page) {
    grid-template-rows: auto 1fr;
  }

  .st-content {
    --link-text-decoration-line: underline;
    --link-text-decoration-thickness: 1px;
    --link-text-decoration-style: dotted;
    --link-active-text-decoration-style: solid;
  }

  .publish-error {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    font-size: 14px;
    font-family: var(--font-sans-serif);
    color: #fff;
    background-color: red;
    padding: 1rem;
  }
</style>
